module.exports = __webpack_public_path__ + "img/gb13871-92_50x68x8.prt.1d3bc94d.jpg";